
import Vue from 'vue';

export default Vue.extend({
	name: 'Loader',

	props: {
		value: { type: Boolean, default: false },
		title: { type: String, default: null },
		subtitle: { type: String, default: null },
		icon: { type: String, default: null },
		loading: { type: Boolean, default: false },
		color: {
			type: String,
			default: 'orange123 lighten-1'
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			}
		}
	}
});
